/* Built In Imports */
/* External Imports */
import { Box, Text, useBreakpointValue } from '@chakra-ui/react';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
/* Services */

/**
 * Renders the MMM Banner component
 *
 * @param {string} title title
 * @param {string} desc description
 * @param {string} lang language
 * @param {string} mobileImg url
 * @param {string} desktopImg url
 * @param {string} lang language
 * @param {string} page page name
 * @returns {ReactElement} MMM Banner component
 */

const MMMBanner = ({ title, desc, mobileImg, desktopImg, lang, page }) => {
  const imageSrc = useBreakpointValue({
    base: mobileImg,
    sm: mobileImg,
    md: desktopImg,
  });

  let _bgColor = '';
  switch (title) {
    case 'Man':
      _bgColor =
        'linear-gradient(114deg, #050602 0%, #160b09 62%, #d7c1b2 96%, #c6b3b7 100%)';
      break;
    case 'Mystic':
      _bgColor =
        'linear-gradient(3deg, #ffffff 15%, #fbfbfb 8%, #020202 9%, #000000 100%)';
      break;
    case 'Mission':
      _bgColor = 'linear-gradient(90deg, #020202 0%, #7b5445 100%)';
      break;
  }

  return (
    <>
      <Box
        bgColor={{ base: '#000000', sm: 'inherit' }}
        float="left"
        width="100%"
        pos="relative"
        marginBottom={{
          base: '55px',
          sm: '55px',
          md: '0',
        }}
      >
        <Box
          float="left"
          w="100%"
          minHeight={{ base: '322px', md: '320px', lg: '500px' }}
          pos="relative"
          bgGradient={_bgColor}
          bgColor="#1d1914"
          bgImage={imageSrc}
          bgSize="cover"
          bgPos="0%"
          bgRepeat="no-repeat"
          clipPath={{
            base: 'polygon(0px 0px, 100% 0px, 100% 100%, 0 90%)',
            md: 'polygon(0px 0px, 100% 0px, 100% 97%, 0 91%)',
          }}
        ></Box>
        <Box
          float="left"
          w={{ base: '100%', sm: '100%', md: '80%', lg: '65%' }}
          textAlign="left"
          paddingLeft={{ base: '24px', sm: '24px', md: '50px', lg: '85px' }}
          paddingTop={{
            base: '10px',
            sm: '0',
            md:
              page === 'mission' || (lang === 'ta' && page === 'mystic')
                ? '0'
                : '40px',
            lg: lang === 'ta' && page === 'mystic' ? '0' : '80px',
          }}
          pos={{ base: 'relative', md: 'absolute' }}
          left="0"
          right="0"
          bottom={{ md: 'unset', sm: '26px', base: '0' }}
          backgroundColor={{ base: 'black', md: 'unset' }}
          paddingBottom={{ base: '20px', md: '0' }}
        >
          <Text
            float="left"
            w="100%"
            textAlign="left"
            fontFamily="'FedraSerifAStdBook',sans-serif"
            fontSize={{
              base: '45px',
              lg: '54px',
            }}
            color={'#cf4520'}
            paddingRight={{ base: '0', md: '80px' }}
          >
            {title}
          </Text>
          <Text
            className="desc"
            float="left"
            w={{ base: '100%', sm: '100%', md: '80%', lg: '60%' }}
            textAlign="left"
            fontFamily="FedraSansStd-book,sans-serif"
            fontSize={{
              base: page === 'mission' ? '15px' : '16px',
            }}
            color={'#d6b99b'}
            p="10px 25px 25px 0"
            // dangerouslySetInnerHTML={{ __html: desc }}
          >
            {parser(desc)}
          </Text>
        </Box>
        <style jsx global>{`
          .desc a {
            color: #cf4824;
          }
        `}</style>
      </Box>
    </>
  );
};

export default MMMBanner;
